// extracted by mini-css-extract-plugin
export default {"home":"Invites_home__FbaWr","card":"Invites_card__XDjvJ"};